import { Button, Progress } from "antd";

export const columns = [
  {
    title: "Industries",
    dataIndex: "name",
    render: (text) => <span style={{ fontWeight: 500 }}>{text}</span>,
  },
  {
    title: "Market Widget",
    dataIndex: "overview.market_weight",
    render: (text, row) => {
      let markerWeight = row?.overview?.market_weight * 100;
      markerWeight =
        markerWeight && markerWeight !== 0 ? markerWeight.toFixed(2) : 0;
      return (
        <>
          <Progress
            percent={markerWeight}
            format={(percent) => (
              <span style={{ color: "black" }}>{percent}%</span>
            )}
            percentPosition={{
              type: "outer",
              align: "end",
            }}
            size={[120, 15]}
            strokeColor="#7eabd6"
          />
        </>
      );
    },
  },
  // {
  //   title: "Industries",
  //   dataIndex: "industries_count",
  //   render: (text, row) => {
  //     return row?.overview?.industries_count;
  //   },
  // },
  {
    title: "Companies",
    dataIndex: "companies_count",
    render: (text, row) => {
      return row?.overview?.companies_count;
    },
  },
];
export const mutualFundsColumns = [
  {
    title: "Symbol",
    dataIndex: "symbol",
    key: "symbol",
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
];
export const largestCompaniesColumns = [
  {
    title: "Symbol",
    dataIndex: "symbol",
    key: "symbol",
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Market Weight",
    dataIndex: "marketWeight",
    key: "marketWeight",
    render: (weight) => weight.toFixed(6), // Format market weight to 6 decimal places
  },
  {
    title: "Rating",
    dataIndex: "rating",
    key: "rating",
  },
];
export const etfTableColumns = [
  {
    title: "Symbol",
    dataIndex: "symbol",
    key: "symbol",
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
];
export const dataSource = [
  {
    key: "all_industries",
    industry: "All Industries",
    marketWidget: 100,
    trends: "+25.5%",
  },
  {
    key: "2",
    industry: "Semiconductors",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+12.3%",
  },
  {
    key: "3",
    industry: "Software - Infrastructure",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+8.7%",
  },
  {
    key: "4",
    industry: "Computer Electronics",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+15.2%",
  },
  {
    key: "5",
    industry: "Software - Application",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+10.4%",
  },
  {
    key: "6",
    industry: "Information Technology",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+9.8%",
  },
  {
    key: "7",
    industry: "Communication Equipment",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+18.6%",
  },
  {
    key: "8",
    industry: "Computer Hardware",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+7.3%",
  },
  {
    key: "9",
    industry: "Electronic Components",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+11.1%",
  },
  {
    key: "10",
    industry: "Scientific Institute",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+13.5%",
  },
  {
    key: "11",
    industry: "Solar",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+6.9%",
  },
  {
    key: "12",
    industry: "Technical Institute",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+16.9%",
  },
];


export const largestCompaniesDataSource = [
  {
    key: "1",
    name: "Apple Inc.",
    lastPrice: "$145.86",
    price: "$150.00",
    marketWeight: "6.5%",
    marketCap: "2.4T",
    change: "+0.92%",
    trends: "+2.5%",
    rating: "2.0",
  },
  {
    key: "2",
    name: "Microsoft Corp.",
    lastPrice: "$145.86",
    price: "$150.00",
    marketWeight: "6.5%",
    marketCap: "2.4T",
    change: "+0.92%",
    trends: "+2.5%",
    rating: "2.1",
  },
  {
    key: "3",
    name: "Amazon.com Inc.",
    lastPrice: "$145.86",
    price: "$150.00",
    marketWeight: "6.5%",
    marketCap: "2.4T",
    change: "+0.92%",
    trends: "+2.5%",
    rating: "2.2",
  },
  {
    key: "4",
    name: "Alphabet Inc.",
    lastPrice: "$145.86",
    price: "$150.00",
    marketWeight: "6.5%",
    marketCap: "2.4T",
    change: "+0.92%",
    trends: "+2.5%",
    rating: "2.3",
  },
  {
    key: "5",
    name: "Facebook Inc.",
    lastPrice: "$145.86",
    price: "$150.00",
    marketWeight: "6.5%",
    marketCap: "2.4T",
    change: "+0.92%",
    trends: "+2.5%",
    rating: "2.4",
  },
  {
    key: "6",
    name: "Tesla Inc.",
    lastPrice: "$145.86",
    price: "$150.00",
    marketWeight: "6.5%",
    marketCap: "2.4T",
    change: "+0.92%",
    trends: "+2.5%",
    rating: "2.5",
  },
  {
    key: "7",
    name: "NVIDIA Corp.",
    lastPrice: "$145.86",
    price: "$150.00",
    marketWeight: "6.5%",
    marketCap: "2.4T",
    change: "+0.92%",
    trends: "+2.5%",
    rating: "2.6",
  },
  {
    key: "8",
    name: "PayPal Holdings Inc.",
    lastPrice: "$145.86",
    price: "$150.00",
    marketWeight: "6.5%",
    marketCap: "2.4T",
    change: "+0.92%",
    trends: "+2.5%",
    rating: "2.7",
  },
  {
    key: "9",
    name: "Intel Corp.",
    lastPrice: "$145.86",
    price: "$150.00",
    marketWeight: "6.5%",
    marketCap: "2.4T",
    change: "+0.92%",
    trends: "+2.5%",
    rating: "2.8",
  },
  {
    key: "10",
    name: "Adobe Inc.",
    lastPrice: "$145.86",
    price: "$150.00",
    marketWeight: "6.5%",
    marketCap: "2.4T",
    change: "+0.92%",
    trends: "+2.5%",
    rating: "2.9",
  },
];


export const investingSectorsColumns = [
  {
    title: "Symbol",
    dataIndex: "key",
  },
  {
    title: "Name",
    dataIndex: "name",
    render: (text) => <span style={{ fontWeight: 500 }}>{text}</span>,
  },
];

export const investingSectorsDataSource = [
  {
    key: "1",
    name: "Vanguard Information Technology ETF",
    lastPrice: "$145.86",
    netAsset: "2.4T",
    expenseRatio: "0.92%",
    trends: "+2.5%",
  },
  {
    key: "2",
    name: "Vanguard Health Care ETF",
    lastPrice: "$145.86",
    netAsset: "2.4T",
    expenseRatio: "0.92%",
    trends: "+2.5%",
  },
  {
    key: "3",
    name: "Vanguard Real Estate ETF",
    lastPrice: "$145.86",
    netAsset: "2.4T",
    expenseRatio: "0.92%",
    trends: "+2.5%",
  },
  {
    key: "4",
    name: "Vanguard Consumer Discretionary ETF",
    lastPrice: "$145.86",
    netAsset: "2.4T",
    expenseRatio: "0.92%",
    trends: "+2.5%",
  },
  {
    key: "5",
    name: "Vanguard Consumer Staples ETF",
    lastPrice: "$145.86",
    netAsset: "2.4T",
    expenseRatio: "0.92%",
    trends: "+2.5%",
  },
  {
    key: "6",
    name: "Vanguard Energy ETF",
    lastPrice: "$145.86",
    netAsset: "2.4T",
    expenseRatio: "0.92%",
    trends: "+2.5%",
  },
  {
    key: "7",
    name: "Vanguard Financials ETF",
    lastPrice: "$145.86",
    netAsset: "2.4T",
    expenseRatio: "0.92%",
    trends: "+2.5%",
  },
  {
    key: "8",
    name: "Vanguard Industrials ETF",
    lastPrice: "$145.86",
    netAsset: "2.4T",
    expenseRatio: "0.92%",
    trends: "+2.5%",
  },
  {
    key: "9",
    name: "Vanguard Materials ETF",
    lastPrice: "$145.86",
    netAsset: "2.4T",
    expenseRatio: "0.92%",
    trends: "+2.5%",
  },
];
export const investingSectorsDataSource2 = [
  {
    key: "10",
    name: "Vanguard Utilities ETF",
    lastPrice: "$145.86",
    netAsset: "2.4T",
    expenseRatio: "0.92%",
    trends: "+2.5%",
  },
  {
    key: "11",
    name: "Vanguard Communication Services ETF",
    lastPrice: "$145.86",
    netAsset: "2.4T",
    expenseRatio: "0.92%",
    trends: "+2.5%",
  },
  {
    key: "12",
    name: "Vanguard Mid-Cap ETF",
    lastPrice: "$145.86",
    netAsset: "2.4T",
    expenseRatio: "0.92%",
    trends: "+2.5%",
  },
  {
    key: "13",
    name: "Vanguard Small-Cap ETF",
    lastPrice: "$145.86",
    netAsset: "2.4T",
    expenseRatio: "0.92%",
    trends: "+2.5%",
  },
  {
    key: "14",
    name: "Vanguard Large-Cap ETF",
    lastPrice: "$145.86",
    netAsset: "2.4T",
    expenseRatio: "0.92%",
    trends: "+2.5%",
  },
  {
    key: "15",
    name: "Vanguard Growth ETF",
    lastPrice: "$145.86",
    netAsset: "2.4T",
    expenseRatio: "0.92%",
    trends: "+2.5%",
  },
  {
    key: "16",
    name: "Vanguard Value ETF",
    lastPrice: "$145.86",
    netAsset: "2.4T",
    expenseRatio: "0.92%",
    trends: "+2.5%",
  },
  {
    key: "17",
    name: "Vanguard Dividend Appreciation ETF",
    lastPrice: "$145.86",
    netAsset: "2.4T",
    expenseRatio: "0.92%",
    trends: "+2.5%",
  },
  {
    key: "18",
    name: "Vanguard High Dividend Yield ETF",
    lastPrice: "$145.86",
    netAsset: "2.4T",
    expenseRatio: "0.92%",
    trends: "+2.5%",
  },
];
